module.exports = __webpack_public_path__ + "img/img11.884d521a.png";